import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { filmographyGroups } from '@/mocks/mikami/filmography';

export default function FilmographySection() {
  const [openId, setOpenId] = useState<string>(filmographyGroups[0]?.id ?? '');

  return (
    <section id="filmography" className="anchor-offset bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="作品年表"
          title="按阶段梳理的整体脉络"
          description="年表把内容分成最新整理、近年回顾与早期内容三个阶段，便于横向比较风格变化。点击每个阶段即可展开查看该阶段的具体条目与说明。"
        />

        <div className="max-w-4xl space-y-3">
          {filmographyGroups.map((group) => {
            const isOpen = group.id === openId;
            return (
              <div key={group.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? '' : group.id)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/60"
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-stack-line text-lg"></i>
                    </span>
                    <span>
                      <span className="block font-heading text-base font-bold text-foreground-950 md:text-lg">{group.title}</span>
                      <span className="mt-0.5 block text-xs text-foreground-500">{group.caption}</span>
                    </span>
                  </span>
                  <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg text-foreground-600`}></i>
                </button>

                {isOpen && (
                  <ul className="space-y-3 border-t border-background-200 px-5 py-4">
                    {group.items.map((item) => (
                      <li key={item.id} className="rounded-md bg-background-50 p-4">
                        <div className="flex flex-wrap items-center justify-between gap-2">
                          <h3 className="font-heading text-sm font-bold text-foreground-900 md:text-base">{item.name}</h3>
                          <div className="flex flex-wrap gap-1.5">
                            {item.tags.map((tag) => (
                              <span
                                key={tag}
                                className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-label text-accent-800"
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.note}</p>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}